var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.305,
    height: 16.043,
    viewBox: "0 0 12.305 16.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74447",
    "data-name": "Group 74447",
    transform: "translate(-1159 -159.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "da086273b974cb595139babd4da17772",
    d: "M176.3,90.269l-.259,7.822a2.577,2.577,0,0,1-2.585,2.49h-4.91a2.577,2.577,0,0,1-2.585-2.49l-.258-7.825A.647.647,0,1,1,167,90.224l.258,7.824a1.292,1.292,0,0,0,1.292,1.245h4.91a1.292,1.292,0,0,0,1.292-1.245l.258-7.821a.647.647,0,1,1,1.292.043Zm.852-2.6a.646.646,0,0,1-.646.646H165.5a.646.646,0,0,1,0-1.292h2a.824.824,0,0,0,.822-.742,1.933,1.933,0,0,1,1.928-1.741h1.507a1.933,1.933,0,0,1,1.928,1.741.824.824,0,0,0,.822.742h2a.646.646,0,0,1,.646.646Zm-7.712-.646h3.119a2.132,2.132,0,0,1-.164-.61.646.646,0,0,0-.642-.582h-1.507a.646.646,0,0,0-.642.582,2.132,2.132,0,0,1-.165.61Zm.651,9.789v-5.5a.646.646,0,1,0-1.292,0v5.5a.646.646,0,1,0,1.292,0Zm3.11,0v-5.5a.646.646,0,1,0-1.292,0v5.5a.646.646,0,1,0,1.292,0Z",
    transform: "translate(994.147 74.76)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1daaca7a85f6e43649b4678d6dc4976b.svg";
export { ForwardRef as ReactComponent };